import React, { FunctionComponent, useEffect } from 'react'
import { WhiteGreyBtn } from 'Stories/Button/Button.stories'

import { useTranslation } from 'react-i18next'
import { IconSuccessfully } from 'Stories/Icon/Icon.stories'

import { SuccessfulyAddedTrackProps } from './SuccessfulyAddedTrackProps'

import {
  SuccessMessage,
  SuccessContent,
  SuccessText,
  SuccessCircle,
  SuccessTitle,
} from './styles'

const SuccessfulyAddedTrack: FunctionComponent<SuccessfulyAddedTrackProps> = ({
  toggle,
}) => {
  const { t } = useTranslation()

  useEffect(() => {
    const timer = setTimeout(() => toggle(), 3000)
    return () => clearTimeout(timer)
  }, [])

  return (
    <SuccessMessage>
      <SuccessContent>
        <SuccessText>
          <SuccessCircle>
            <IconSuccessfully />
          </SuccessCircle>
          <SuccessTitle>
            {t('createCampaignPage.yourTrackSuccessfulyAdded')}
          </SuccessTitle>
        </SuccessText>

        <WhiteGreyBtn color="white" onClick={toggle}>
          {t('createCampaignPage.close')}
        </WhiteGreyBtn>
      </SuccessContent>
    </SuccessMessage>
  )
}

export default SuccessfulyAddedTrack
